{
	"loading_reservations_text": "Nimm dir einen Moment der Entspannung, wir laden deine Reservierungen für dich.",
	"only_the_most_recent_reservations_shown_text": "Es werden nur die 50 neuesten Reservierungen angezeigt.",
	"homeScreen": "Startseite",
	"close": "Schließen",
	"done": "Fertig",
	"delete": "Löschen",
	"per_person_short": "pro Person",
	"starting_from_short": "ab",
	"book_now": "Buchen",
	"more_info": "Mehr Informationen",
	"next": "Weiter",
	"previous": "Vorherige",
	"login_or_register": "Anmelden oder Registrieren",
	"cancel": "Abbrechen",
	"are_you_sure_you_want_to_logout": "Sind Sie sicher, dass Sie sich abmelden möchten?",
	"continue": "Weiter",
	"do_login": "Einloggen",
	"do_register": "Registrieren",
	"login_with_password": "Mit Passwort einloggen",
	"login_with_magiclink": "Mit Link einloggen",
	"madam": "Frau",
	"sir": "Herr",
	"gender_prefer_not_to_say": "Sage ich lieber nicht",
	"go_back": "Zurück",
	"first_name": "Vorname",
	"infix_name": "Namenszusatz",
	"last_name": "Nachname",
	"email_address": "E-Mail-Adresse",
	"email_address_invalid": "Geben Sie eine gültige E-Mail-Adresse ein",
	"password": "Passwort",
	"password_with_rules": "Passwort (mind. 8 Zeichen)",
	"repeat_password": "Passwort wiederholen",
	"show_password": "Passwort anzeigen",
	"hide_password": "Passwort verbergen",
	"resend": "Erneut senden",
	"you_are_almost_there": "Sie sind fast da...",
	"unknown_error_occurred": "Ein unbekannter Fehler ist aufgetreten",
	"view": "Ansehen",
	"book": "Buchen",
	"sendAMessage": "Nachricht senden",
	"check_your_email_and_click_on_the_link_to_confirm_your_registration": "Überprüfen Sie Ihre E-Mail und klicken Sie auf den Link, um Ihre Registrierung zu bestätigen.",
	"are_you_sure_you_want_to_reset_your_password": "Sind Sie sicher, dass Sie Ihr Passwort zurücksetzen möchten?",
	"an_email_is_on_its_way_to_you": "Eine E-Mail ist auf dem Weg zu Ihnen",
	"your_account_must_be_verified_before_you_can_log_in_an_email_has_been_sent_to_you_with_a_verification_link": "Ihr Konto muss verifiziert werden, bevor Sie sich einloggen können. Ihnen wurde eine E-Mail mit einem Verifizierungslink gesendet.",
	"click_on_the_link_in_the_email_to_log_in_immediately_didnt_receive_an_email_it_may_take_a_few_minutes_before_you_receive_the_email_also_just_to_be_sure_check_your_junk_mail": "Klicken Sie auf den Link in der E-Mail, um sich sofort einzuloggen. Haben Sie keine E-Mail erhalten? Es kann einige Minuten dauern, bis Sie die E-Mail erhalten. Überprüfen Sie auch Ihren Spam-Ordner.",
	"message_category_booking": "Buchung",
	"message_category_news": "Nachrichten",
	"show_all": "Alles anzeigen",
	"messages": "Meine Nachrichten",
	"message": "Nachricht",
	"reply_on_this_message": "Auf diese Nachricht antworten",
	"send": "Senden",
	"sendAs": "Als Absender senden",
	"subject": "Betreff",
	"reservation_number_form_title": "Über welchen Vorbehalt berichten Sie? (Optional)",
	"reservation_number": "Reservierungsnummer",
	"something_went_wrong_title": "Etwas ist schiefgelaufen.",
	"something_went_wrong_message": "Überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
	"too_many_requests": "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
	"try_again": "Versuchen Sie es erneut",
	"thermen_resort_general_form_title": "Über welches Resort berichten Sie?",
	"thermen_resort_general": "Thermen Resorts (allgemein)",
	"select_a_thermen_resort": "Wählen Sie ein Thermen Resort",
	"save": "speichern",
	"your_adjustment_has_been_processed_in_our_database_it_may_take_up_to_24_hours_for_your_adjustment_to_be_processed": "Ihre Anpassung wurde in unserer Datenbank verarbeitet. Es kann bis zu 24 Stunden dauern, bis Ihre Anpassung bearbeitet wird.",
	"not_available_short": "n/a",
	"video": "Video",
	"response": "Antwort",
	"your_response_has_been_sent": "Ihre Antwort wurde gesendet",
	"thanks_for_your_message_we_will_contact_you_by_email_as_soon_as_possible": "Thanks for your message. We will contact you by email as soon as possible.",
	"please_note_have_you_requested_a_change_you_will_then_receive_a_new_confirmation_of_your_adjusted_reservation_by_email_from_us_as_soon_as_you_have_received_this_email_this_change_will_also_be_visible_in_the_app_within_an_hour": "Please note: have you requested a change? You will then receive a new confirmation of your adjusted reservation by email from us. As soon as you have received this email, this change will also be visible in the app within an hour.",
	"resort_info": "Resort-Info",
	"delete_account": "Konto löschen",
	"are_you_sure_you_want_to_delete_your_account": "Achtung! Du bist dabei, dein Konto zu löschen. Du verlierst den Zugriff auf dein Konto und dein aufgebauter Thermenfans-Status verfällt.",
	"current_password": "Aktuelles Passwort",
	"add": "Einfügen",
	"video_tutorials": "Video-Tutorials",
	"tutorials_title": "Sehen Sie sich unsere praktischen Video-Tutorials an",
	"tutorials_description": "Wie erstelle ich ein Konto bei Thermen Resorts und wie kann ich meine Thermenfans-Vorteile einlösen? Wir haben verschiedene Videos erstellt, um Ihnen bei diesen und anderen praktischen Fragen zu helfen. Haben Sie nach dem Anschauen unserer Videos noch Fragen? Dann können Sie auch bei unseren häufig gestellten Fragen nachsehen!",
	"which_reservation_are_you_reporting_about_question": "Über welchen Vorbehalt berichten Sie?",
	"optional": "optional",
	"general_thermen_resorts": "Allgemein/Thermen Resorts",
	"ignore": "Ignorieren",
	"update": "Aktualisieren",
	"swimwear_day": "Badekleidungstag",
	"filter_swimwear_days": "Nach Badekleidungstagen filtern",
	"app_version": "App Version: {{appVersion}} ({{buildVersion}})",
	"add_reservation_manually_description": "Ist deine Reservierung nicht aufgeführt? Dann kannst du sie manuell hinzufügen, indem du die Reservierungsnummer verwendest, die du per E-Mail erhalten hast.",
	"enter_manually": "Manuell hinzufügen",
	"add_reservation_manually": "Reservierung manuell hinzufügen",
	"fill_in_all_required_fields": "Bitte füllen Sie alle erforderlichen Felder aus.",
	"onboarding": {
		"step1": {
			"header": "Tauchen Sie ein in unsere Welt der Entspannung",
			"description": "Buchen, sparen und genießen."
		},
		"step2": {
			"header": "Entdecken Sie, welche Vorteile auf Sie warten",
			"description": "Persönliche Angebote und Vorteile für unsere echten Thermenfans."
		},
		"step3": {
			"header": "Buchen Sie einfach und verwalten Sie Ihre Reservierungen",
			"description": "Alles an einem Ort."
		},
		"step4": {
			"header": "Entspannen Sie sich und genießen Sie angenehme Momente",
			"description": "Unsere Thermal-Experten helfen Ihnen mit praktischen Tipps, Inspiration und Übungen."
		}
	},
	"login": {
		"overlay_tagline": "Entdecken Sie Ihre Vorteile",
		"step1": {
			"header": "Einloggen oder registrieren",
			"description": "Wir prüfen, ob Sie bereits ein Konto bei uns haben."
		},
		"step2": {
			"header": "Schön, dass Sie hier sind!"
		},
		"step3": {
			"header": "Mit Passwort einloggen"
		},
		"forgot_password_link": "Passwort vergessen?",
		"email_password_combination_invalid_error": "Die Kombination aus dieser E-Mail-Adresse und diesem Passwort ist uns nicht bekannt.",
		"magiclink_invalid_error": "Dieser Magiclink scheint nicht mehr gültig zu sein. Versuchen Sie es erneut."
	},
	"register": {
		"step2": {
			"header": "Konto erstellen",
			"description": "Wir lernen Sie gerne besser kennen. Geben Sie hier Ihre Daten ein:"
		}
	},
	"Preferences": {
		"upcomingReservations": "Kommende Reservierungen",
		"language": "Sprache",
		"english": "Englisch",
		"german": "Deutsch",
		"spanish": "Spanisch",
		"russian": "Russisch"
	},
	"dashboard": {
		"prepare": {
			"title": "Optimale Vorbereitung"
		}
	},
	"resort": {
		"contact": "Kontakt",
		"routeDescription": "Wegbeschreibung"
	},
	"home": {
		"upcomingReservations": "Kommende Reservierungen",
		"title": "Optimale Vorbereitung",
		"completeStay": "Ihren Aufenthalt vervollständigen",
		"discover": "Entdecken",
		"discoverMore": "Mehr entdecken",
		"easyBooking": "Einfache Buchung",
		"comeResorts": "Besuchen Sie eines unserer Resorts",
		"manageBooking": "Verwalten Sie Ihre Reservierung",
		"arrangeApp": "Alles über die App regeln",
		"featured": "Vorgestellt",
		"featuredSubtitle": "Aus unseren Resorts",
		"arrangement": "Angebot",
		"mostBooked": "Am häufigsten gebucht",
		"discoverOurThermenResorts": "Entdecken Sie unsere Thermenresorts",
		"reserveVisit": "Reservieren Sie Ihren Besuch",
		"reserve": "Reservieren",
		"viewReservation": "Ansehen",
		"showBarcode": "Barcode anzeigen"
	},
	"tabs": {
		"home": "Startseite",
		"booking": "Buchen",
		"thermenfans": "Thermenfans",
		"relaxation": "Entspannung",
		"bathCard": "Badekarte",
		"account": "Konto"
	},
	"headers": {
		"account": "Mein Konto"
	},
	"bathcard": {
		"url": "https://thermenresorts.de/badekarte",
		"addBathcard": "Vorhandene Karte verknüpfen",
		"buyBathcard": "Badekarte kaufen",
		"leaveAppDescription": "Wir leiten Sie zur Website weiter, um Ihre Badekarte zu kaufen.",
		"balanceDelayTooltip": "Es kann einen Moment dauern, bis das aktuelle Guthaben der Badenkarte aktualisiert ist.",
		"areYouSureDeleteBathcard": "Sind Sie sicher, dass Sie diese Karte löschen möchten?",
		"areYouSureUnlinkBathcard": "Diese Badekarte hat noch ein offenes Guthaben. Möchten Sie sie wirklich entkoppeln?",
		"cards": "Badekarten",
		"loading": "Badekarte wird geladen",
		"cardSummary": "Sie haben noch <strong>{{visits}}</strong> bis {{date}} bei {{workspace}}",
		"cardSummaryWithoutExpiry": "Sie haben noch <strong>{{visits}}</strong> bei {{workspace}}",
		"visitOne": "1 Besuch",
		"visitsOther": "{{count}} Besuche",
		"reserve": "Reservieren",
		"noCardHeading": "Noch keine Badekarte?",
		"extraCardHeading": "Zusätzliche Badekarte?",
		"acquireIntro": "Profitieren Sie in Ihrem Lieblings-Thermenresort mit einer 10er- oder 20er-Badekarte.",
		"linkCard": "Karte verknüpfen",
		"buyCard": "Karte kaufen",
		"uspsTitle": "Ihre Badekarten-Vorteile",
		"yourBathcard": "Ihre Badekarte",
		"view": "Ansehen",
		"buyNewCard": "Neue Badekarte kaufen",
		"removeThisCard": "Diese Karte entfernen",
		"unlink": "Entkoppeln",
		"unlinkThisCard": "Diese Karte entkoppeln"
	},
	"loyalty": {
		"selectResort": "Wählen Sie Ihre Resort aus",
		"sale": "Rabatt",
		"redeem": "Einlösen",
		"moreInfo": "Mehr Infos",
		"discoverMyBenefits": "Entdecke deine Vorteile",
		"download_voucher": "Gutschein herunterladen",
		"benefits": "Ihre Thermenfans-Vorteile",
		"personalBenefitsWithCount": "Ihre {{count}} persönlichen Vorteile",
		"benefitsSubtitle": "Von diesem Monat",
		"useBenefit": "Nutzen",
		"benefitUsed": "Genutzt",
		"useThisBenefit": "Diesen Vorteil nutzen",
		"youUsedThisBenefit": "Sie haben diesen Vorteil bereits genutzt"
	},
	"account": {
		"upcomingReservations": "Kommende Reservierungen",
		"pastReservations": "Vergangene Reservierungen",
		"noUpcomingReservations": "Keine bevorstehenden Reservierungen gefunden.",
		"noPastReservations": "Keine früheren Reservierungen gefunden.",
		"myDetails": "Meine Daten",
		"mail": "E-Mail",
		"changePersonalDetails": "Persönliche Daten",
		"changeAdressDetails": "Adressdaten",
		"closeModal": "Schließen",
		"resetConfirm": "Sind Sie sicher, dass Sie Ihr Passwort zurücksetzen möchten?",
		"resetConfirmed": "Wir haben dir den Link zum Zurücksetzen des Passworts per E-Mail gesendet!",
		"resetDescription": "Es wird eine E-Mail an Ihre E-Mail-Adresse gesendet, wenn Sie auf 'Passwort zurücksetzen' klicken. In dieser E-Mail befindet sich ein Link, um ein neues Passwort anzufordern.",
		"resetDescriptionSuccess": "Klicke auf den Link in der E-Mail, um dein Passwort zu ändern. Keine E-Mail erhalten? Es kann einige Minuten dauern, bis du die E-Mail erhältst. Überprüfe auch sicherheitshalber deinen Spam-Ordner.",
		"resetPassword": "Passwort zurücksetzen",
		"attention": "Achtung",
		"deleteWarning": "Ihr Konto und Ihr Thermenfans-Status werden hiermit gelöscht.",
		"myPreferences": "Meine Einstellungen",
		"preferences": {
			"notifications": "Benachrichtigungen",
			"emails": "E-Mails",
			"preferredLanguage": "Bevorzugte Sprache",
			"newsletterDetail": "Nichts mehr verpassen? Seien Sie einer der Ersten, die unsere neuesten Nachrichten erhalten. Sie können selbst auswählen, welche E-Mails Sie erhalten möchten.",
			"languageDetail": "Entspannen Sie auf Ihre Weise. In Ihrer Sprache. Wählen Sie Ihre bevorzugte Sprache aus."
		},
		"emailDescriptionPreferences": "Wählen Sie selbst aus, welche Nachrichten Sie von uns erhalten möchten. Passen Sie Ihre Einstellungen an und erhalten Sie jede Woche Nachrichten zu den von Ihnen ausgewählten Themen.",
		"sendAMessage": "Kontakt aufnehmen",
		"appExplanation": "Erklärung zur App",
		"logout": "Abmelden"
	},
	"resetpassword": {
		"closeModal": "Schließen",
		"resetConfirm": "Sind Sie sicher, dass Sie Ihr Passwort zurücksetzen möchten?",
		"resetConfirmed": "Wir haben dir den Link zum Zurücksetzen des Passworts per E-Mail gesendet!",
		"resetDescription": "Es wird eine E-Mail an Ihre E-Mail-Adresse gesendet, wenn Sie auf 'Passwort zurücksetzen' klicken. In dieser E-Mail befindet sich ein Link, um ein neues Passwort anzufordern.",
		"resetDescriptionSuccess": "Klicke auf den Link in der E-Mail, um dein Passwort zu ändern. Keine E-Mail erhalten? Es kann einige Minuten dauern, bis du die E-Mail erhältst. Überprüfe auch sicherheitshalber deinen Spam-Ordner.",
		"resetPassword": "Passwort zurücksetzen"
	},
	"reservation": {
		"bookAgain": "Erneut buchen",
		"viewReservation": "Reservierung anzeigen",
		"id": "Reservierungs-ID",
		"booking": "Buchung",
		"included": "Inklusive",
		"location": "Ort",
		"price": "Preis",
		"questionOrChange": "Haben Sie Fragen oder möchten Sie Ihre Reservierung ändern?",
		"addPreferencesHeading": "Geben Sie Ihre Vorlieben an!",
		"addPreferences": "Vorlieben angeben",
		"addPreferencesText": "Ein unvergesslicher Aufenthalt voller Luxus, Entspannung und Verwöhnung erwartet Sie bald.",
		"sendAMessage": "Senden Sie uns eine Nachricht",
		"callUs": "Rufen Sie uns an",
		"personCount": "Person",
		"personCounts": "Personen",
		"showBarcode": "Barcode anzeigen",
		"yourReservation": "Ihre Reservierung",
		"unknown": "Unbekannt"
	},
	"dialog": {
		"barcode": "Barcode"
	},
	"settings": {
		"update_available": "Update verfügbar",
		"update_available_description": "Ein Update für die Thermen Resorts App ist verfügbar.",
		"update_available_mandatory": "Update erforderlich",
		"update_available_mandatory_description": "Die Thermen Resorts App benötigt ein Update.",
		"update_available_version_text": "Sie verwenden derzeit die Version {{currentVersion}}. Version {{newVersion}} ist verfügbar."
	},
	"select_resort": "Wählen Sie ein Thermenresort",
	"select_resort_error": "Wählen Sie ein Resort für Ihre Frage aus",
	"enter_subject": "Geben Sie ein Betreff ein",
	"enter_message": "Geben Sie eine Nachricht ein",
	"url_could_not_be_opened_title": "URL konnte nicht geöffnet werden",
	"url_could_not_be_opened_description": "Die URL konnte nicht geöffnet werden. Überprüfen Sie, ob ein externer Browser installiert ist.",
	"copy_url": "URL kopieren",
	"okay": "Okay",
	"readMore": "Mehr lesen",
	"check_your_advantages": "Ihre Vorteile",
	"exclusive_access_to_personal_advantages": "Exklusive persönliche Vorteile",
	"easy_way_to_manage_your_reservations": "Reservierungen einfach verwalten",
	"enjoy_relaxation_at_home": "Genießen Sie Entspannung zu Hause",
	"duration_minutes": "{{minutes}} Min.",
	"exercise_of_the_day": "Übung des Tages",
	"play_video": "Video abspielen",
	"stop_video": "Video stoppen",
	"unavailable_in_active_locale_message": "Achtung: Du wirst auf unsere englische Website weitergeleitet.",
	"reserve": {
		"url": "https://www.thermenresorts.de/reservieren",
		"withLoyalty": "Mit Thermenfans-Vorteilen",
		"withLoyaltyDescription": "Nutzen Sie Ihren Status und Ihre Vorteile",
		"withBathCard": "Mit Ihrer Badekarte",
		"withBathCardDescription": "Badekarte kaufen oder verknüpfen",
		"standard": "Standardreservierung",
		"standardDescription": "Über die Website, immer aktuelle Verfügbarkeit",
		"leaveAppDescription": "Wir leiten Sie zur Website weiter, um die aktuelle Verfügbarkeit zu sehen und zu reservieren."
	},
	"leaveApp": {
		"title": "Sie verlassen die App",
		"description": "Wir leiten Sie zu einer Website außerhalb der App weiter.",
		"confirm": "Weiter zur Website"
	}
}
